import _ from 'lodash';
import { FreshDeskService } from './fresh-desk.service';

export class FreshDeskHelper {
  private static emailAddress: any;
  private static customerNumber: any;

  private static ticketPayload: any;
  private static setContactAdditionalCustomFields: any;

  private static contactId: any;
  private static companyId: any;
  private static newUser: boolean;

  static async submitFreshDeskTicket(
    customerNumber?: any,
    email?: any,
    payLoad?: any,
    setContactAdditionalCustomFields?: any
  ): Promise<boolean> {
    // assign class global variables.
    FreshDeskHelper.setCustomerInfo(customerNumber, email, payLoad, setContactAdditionalCustomFields);
    // customer number and email calls.
    await FreshDeskHelper.getIds();
    // check for values
    if (!(FreshDeskHelper.companyId && FreshDeskHelper.contactId)) {
      // check company call.
      await FreshDeskHelper.checkCompany();
    }

    // confirm company.
    if (!FreshDeskHelper.companyId) {
      // create company.
      const res = await FreshDeskService.createCompany(FreshDeskHelper.customerNumber) as any;
      FreshDeskHelper.setContactId(res?.id);
      // set newUser to true.
      FreshDeskHelper.newUser = true;
      // recheck email endpoint if company was created.
      await FreshDeskHelper.checkEmailAddress();
    }

    // if existing user then set contact before creating ticket.
    if (!FreshDeskHelper.newUser) {
      await FreshDeskHelper.setFreshDeskContact();
    }

    // fire off create ticket - boolean response.
    return await FreshDeskHelper.createTicket();
  }

  static setCustomerInfo(customerNumber: any, email: any, payLoad: any, setContactAdditionalProps?: any) {
    FreshDeskHelper.customerNumber = customerNumber;
    FreshDeskHelper.emailAddress = email;
    FreshDeskHelper.ticketPayload = payLoad;
    FreshDeskHelper.setContactAdditionalCustomFields = setContactAdditionalProps;
  }

  static async getIds() {
    // call for customer number.
    await FreshDeskHelper.checkCustomerNumber();

    // either contactId or companyId may have a value or not.
    if (!FreshDeskHelper.contactId || !FreshDeskHelper.companyId) {
      // call for customer email address.
      await FreshDeskHelper.checkEmailAddress();
    };
  }

  static async checkCustomerNumber() {
    const res = await FreshDeskService.getContactsSearch(FreshDeskHelper.customerNumber) as any;
    FreshDeskHelper.checkForCustomerNumberResponseIds(res);
  }

  static async checkEmailAddress() {
    const res = await FreshDeskService.getContactEmail(FreshDeskHelper.emailAddress) as any;
    FreshDeskHelper.checkForEmailResponseIds(res);
  }

  static async checkCompany() {
    const res = await FreshDeskService.getCompanies(FreshDeskHelper.customerNumber) as any;
    FreshDeskHelper.checkForCompanyId(res);
  }

  static setContactId(contactId: any) {
    // if there is a value, then set it.
    FreshDeskHelper.contactId = contactId || FreshDeskHelper.contactId;
  }

  static setCompanyId(companyId: any) {
    // if there is a value, then set it.
    FreshDeskHelper.companyId = companyId || FreshDeskHelper.companyId;
  }

  static checkForCompanyId(res: any) {
    if (!res) {
      return;
    };

    const tempObj = res.companies.find((item: any) => {
      return item?.name === FreshDeskHelper.customerNumber;
    });

    // object check
    if (tempObj) {
      FreshDeskHelper.setCompanyId(tempObj?.id);
    };
  }

  static checkForCustomerNumberResponseIds(res: any) {
    if (!res && res.results && res.results.length) {
      return;
    };

    const tempObj = res.results.find((item: any) => {
      return item?.company_id
        && item.company_id > 0
        && item?.company?.name === FreshDeskHelper.customerNumber;
    });

    // object check
    if (tempObj) {
      FreshDeskHelper.setContactId(tempObj?.id);
      FreshDeskHelper.setCompanyId(tempObj?.company_id);
    };
  }

  static checkForEmailResponseIds(res: any) {
    if (!(res && res.length)) {
      return;
    };

    const tempObj = res.find((item: any) => {
      return item?.company_id?.toString() === FreshDeskHelper.customerNumber
        || item?.email === FreshDeskHelper.emailAddress;
    });

    // object check
    if (tempObj) {
      FreshDeskHelper.setContactId(tempObj?.id);
      FreshDeskHelper.setCompanyId(tempObj?.company_id);
    };
  }

  static async createTicket() {
    const res = await FreshDeskService.createTicket(FreshDeskHelper.ticketPayload);

    if (!res) {
      return false;
    };

    if (FreshDeskHelper.newUser) {
      // recheck email endpoint if company was created.
      await FreshDeskHelper.checkEmailAddress();
      // setContact.
      await FreshDeskHelper.setFreshDeskContact();
    };

    return res;
  }

  static async setFreshDeskContact() {
    // fail safe checks.
    if (!(FreshDeskHelper.contactId && FreshDeskHelper.companyId)) {
      return;
    };

    let setContactObj: any = {
      company_id: FreshDeskHelper.companyId,
      custom_fields: {
        customer_number: FreshDeskHelper.customerNumber
      }
    };

    if (FreshDeskHelper.setContactAdditionalCustomFields && FreshDeskHelper.setContactAdditionalCustomFields.custom_fields) {
      // additional check to confirm setContactAdditionalCustomFields is an object that won't 
      // overwrite the required "customer_number" field.
      setContactObj = _.merge(setContactObj, FreshDeskHelper.setContactAdditionalCustomFields);
    };

    await FreshDeskService.setContact(FreshDeskHelper.contactId, setContactObj);
  }
}